import React from "react";
import Loadable from "../../react-loadable";
const WeaOrgTree = Loadable({
  loader: () => import("./OrgTree"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});

export default WeaOrgTree;



// WEBPACK FOOTER //
// ./ecology9/wea-org-tree/index.js